import Row from 'react-bootstrap/Row';
import styled from 'styled-components';
import {
    BOLD_FONT_WEIGHT,
    LG_PADDING,
    MD_FONT_SIZE,
    SM_FONT_SIZE,
    XL_FONT_SIZE
} from '../../components/Common/StyleElement';

export const AnnotoolSearchRow = styled(Row)`
    padding-bottom: ${LG_PADDING};
`

export const AnnotoolTextbox = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    color: #333;
    cursor: default;
`

export const AnnotoolTextboxTitle = styled.p`
    padding-bottom: 0.5rem;
`

export const AnnotoolTextboxInput = styled.input`
    margin-bottom: 10px;
    line-height: 1.5;
    font-size: 1rem;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 2px;
    box-sizing: border-box;
    cursor: default;
    outline: none;
    padding: 8px 52px 8px 10px;
    transition: all 200ms ease;
    width: 100%;
`
export const AnnotoolIntermediateBox = styled.div`
    width: 100%;
    height: 520px;
    border-radius: 15px;
    padding: 2rem;
    overflow-y: auto;
    box-shadow: 4px 6px 15px rgba(0, 0, 0, 0.2);
    transition: all 0.5s ease-in-out;

`
// export const AnnotoolIntermediateBox = styled.div`
//     width: 100%;
//     height: 520px;
//     border-radius: 15px;
//     padding: 2rem;
//     overflow-y: auto;
//     box-shadow: 4px 6px 15px rgba(0, 0, 0, 0.2);
//     transition: all 0.5s ease-in-out;
//     ${props => !props.disabled ?
//     `box-shadow: 4px 6px 15px rgba(0, 0, 0, 0.2);
//         background-color: #fff;
//         `
//     :
//     `background-color: #EEEEEE;
//         color: #ABABAB;
//         cursor: pointer;
//         &:hover {
//             box-shadow: 4px 6px 15px rgba(0, 0, 0, 0.2);
//             transform: scale(0.98);
//         }
//         `
//     }
// `

export const AnnotoolIntermediateTitle = styled.div`
    font-weight: ${BOLD_FONT_WEIGHT};
    text-transform: uppercase;
    margin-bottom: 2rem;
    font-size: ${MD_FONT_SIZE};
    text-align: center;
`

export const AnnotoolIntermediateText = styled.p`
    font-size: ${SM_FONT_SIZE};
`


export const AnnotoolSearchRowNew = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #f5f5f5; /* Optional: for better UI visibility */
    padding: 10px;
    border-radius: 8px; /* Optional: to make it more beautiful */
    margin-bottom: 10px;
`;

export const DropdownWrapper = styled.div`
    flex: 1;
    margin-right: 5px;

`;

export const SearchBarWrapper = styled.div`
    flex: 4;
    margin-right: 5px;
    margin-top: 10px;
`;

export const ButtonWrapper = styled.div`
    flex: 1;
    margin-top: 5px;
`;